import {appName} from "../config";

/**
 * Constants
 * */
export const moduleName = `buyInOneClick`;
const prefix = `${appName}/${moduleName}`;

export const OPEN_MODAL = `${prefix}/OPEN_MODAL`;
export const CLOSE_MODAL = `${prefix}/CLOSE_MODAL`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    case OPEN_MODAL:
      return {
        ...state,
        isOpen: true
      };

    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false
      };

    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const buyInOneClickSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */

export const openModal = () => ({
  type: OPEN_MODAL
});

export const closeModal = () => ({
  type: CLOSE_MODAL
});
